import { render, staticRenderFns } from "./DialogStdSABEdit.vue?vue&type=template&id=aa0f021e&scoped=true"
import script from "./DialogStdSABEdit.vue?vue&type=script&lang=js"
export * from "./DialogStdSABEdit.vue?vue&type=script&lang=js"
import style0 from "./DialogStdSABEdit.vue?vue&type=style&index=0&id=aa0f021e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0f021e",
  null
  
)

export default component.exports